import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import { EGSpeedDial } from "../../../../../../MainComponents/Button/SpeedDial/SpeedDial";
import { OutlineEdit, TrashCan } from "../../../../../../Icon";
import { useTranslation } from "react-i18next";
import Comments from "../../../../Information/Comments";
import { useReportContext } from "../../../../../ReportContext/useReportContext";

export const Measures = ({
  measures,
  hdlOpenDialog,
  openModalConfirm,
  hdlDeleteMeasure,
  closeModalConfirm,
  getLabelByValue,
  measureCatalogOptions,
}) => {
  const theme = useTheme();
  const [t] = useTranslation("report");
  const { measureOptions } = useReportContext();

  // Resuelve la etiqueta priorizando el catálogo custom; si no encuentra el valor
  // ahí (ej. medidas guardadas antes de activar el catálogo) cae a measureOptions
  // y, como último recurso, muestra el valor crudo para no dejarla en blanco.
  const resolveMeasureLabel = (value) => {
    const fromCatalog = Array.isArray(measureCatalogOptions)
      ? getLabelByValue(measureCatalogOptions, value)
      : null;
    return fromCatalog || getLabelByValue(measureOptions, value) || value;
  };

  return (
    <Box
      px={1.5}
      maxHeight={"40vh"}
      sx={{ overflowY: "auto" }}
      className="rounded"
    >
      {measures.map((measure, i) => (
        <Box
          key={measure.id}
          className={`${i < measures.length - 1 ? "border-bottom" : ""}`}
          sx={{
            py: 1.3,
            minHeight: "50px",
            position: "relative",
            my: "auto",
          }}
        >
          <EGSpeedDial
            sx={{ position: "absolute", right: -4, top: 1.5, scale: 0.8 }}
            tooltipPlacement="top"
            actions={[
              {
                icon: <OutlineEdit color={theme.palette.blue.main} />,
                name: t("Resolution.edit"),
                direction: "top",
                onClick: () => hdlOpenDialog("measures", measure),
              },
              {
                icon: <TrashCan color={theme.palette.error.main} />,
                name: t("Resolution.delete"),
                direction: "top",
                onClick: () =>
                  openModalConfirm({
                    variant: "error",
                    title: t("Resolution.attention"),
                    titleColor: theme.palette.pink.main,
                    description1: t(
                      "Care.deleting_this_measure_will_permanently_erase_all_content"
                    ),
                    question: t("Care.do_you_want_continue"),
                    leftButtonText: t("Resolution.delete"),
                    leftButtonColor: "error",
                    leftButtonVariant: "outlined",
                    onClickLeft: () => hdlDeleteMeasure(measure),
                    rightButtonText: t("Care.cancel"),
                    rightButtonColor: "secondary",
                    onClickRight: () => closeModalConfirm(),
                    ethiquin: "megaphone",
                  }),
              },
            ]}
          />
          <Typography
            mr={0.5}
            color="secondary"
            fontWeight={600}
            variant="body1"
            component="span"
          >
            {`${t("Resolution.measure")} #${i + 1}: `}
          </Typography>

          <Typography
            color="primary"
            variant="body1"
            component="span"
            fontWeight={700}
          >
            {measure.measure !== "another"
              ? resolveMeasureLabel(measure.measure)
              : measure.another_measure}
          </Typography>

          {measure.comment && (
            <Comments
              variant="body1"
              text={measure.comment}
              background="white"
              padding={0.33}
              maxLength={250}
            />
          )}
        </Box>
      ))}
    </Box>
  );
};
